// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/workdoc/pricecompare/priceCompare.css
// module id = 2049
// module chunks = 0